export default __webpack_public_path__ + "static/media/settings.9333f8a1.svg";